import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {
  downloadList,
  downloadListCount,
  clearDownloadList,
} from 'gatsby-theme-kn/src/utils/media_database_download_list'
import MediaDatabaseDownloadListItem from 'gatsby-theme-kn/src/components/technical/MediaDatabaseDownloadListItem'
import ModalModule from 'gatsby-theme-kn/src/components/modules/ModalModule'
import useModal from 'gatsby-theme-kn/src/hooks/useModal'
import ModalMediaDatabaseDownloadList from 'gatsby-theme-kn/src/components/modules/ModalMediaDatabaseDownloadList'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import { apiURL } from 'gatsby-theme-kn/src/utils/partner_portal_spa'

const MediaDatabaseDownloadList = ({ DownloadListMode, setter }) => {
  const { t } = useTranslation()

  const [isOpen, setIsOpen] = useState(true)

  // Modal: Download-List
  const [modalState, setModalState] = useState(false)
  const [downloadListId, setDownloadListId] = useState(false)

  const [Fdata, setFdata] = useState(false)
  const [partnerPortalUrl, setPartnerPortalUrl] = useState(null)
  const { data, loading, error } = useAxiosPartnerPortal(
    partnerPortalUrl,
    Fdata,
    'post'
  )

  const openModal = () => {
    let d = new FormData()
    downloadList().map((item) => {
      d.append('upload_list[data][]', item)
    })
    setFdata(d)
    setPartnerPortalUrl(apiURL('upload_lists'))
    setModalState(true)
  }
  const closeModal = () => {
    setModalState(false)
  }

  useEffect(() => {
    if (data) {
      setDownloadListId(data.id)
    }
  }, [data])

  useEffect(() => {
    setPartnerPortalUrl(null)
  }, [downloadListCount()])

  return (
    <>
      <ModalModule
        isOpen={modalState}
        closeModal={closeModal}
        title={t('generic.spa.media.index.download_list')}
      >
        <ModalMediaDatabaseDownloadList downloadListId={downloadListId} />
      </ModalModule>
      {DownloadListMode && (
        <section
          className={`media-cart active ${isOpen === true ? 'open' : ''}`}
        >
          <div className="media-cart-header" data-toggle="media-cart-state">
            <div className="media-cart-header-controls">
              <a
                title={t('generic.spa.media.index.clear')}
                className="btn btn-sm btn-secondary btn-plain"
                data-toggle="media-cart-clear"
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  clearDownloadList(setter)
                  setPartnerPortalUrl(null)
                }}
              >
                <i className="far fa-times"></i>
              </a>
              <a
                title={t('generic.spa.media.index.save')}
                className="btn btn-sm btn-primary btn-plain"
                disabled={downloadList().length === 0}
                data-toggle="media-cart-save"
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  if (downloadList().length > 0) {
                    openModal()
                  }
                }}
              >
                <i className="far fa-save"></i>
              </a>
              {isOpen && (
                <a
                  className="media-cart-toggle"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault()
                    setIsOpen(false)
                  }}
                >
                  <i className="far fa-chevron-down"></i>
                </a>
              )}
              {!isOpen && (
                <a
                  className="media-cart-toggle"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault()
                    setIsOpen(true)
                  }}
                >
                  <i className="far fa-chevron-up"></i>
                </a>
              )}
            </div>
            <h5>
              {t('generic.spa.media.index.download_list')}
              <span
                className="badge bg-primary media-cart-count"
                style={{ marginLeft: '0.25rem' }}
              >
                {downloadListCount()}
              </span>
            </h5>
          </div>
          <ul className="media-cart-list list-inline">
            {downloadList().map((item, index) => (
              <li key={index} className="media-cart-list-item list-inline-item">
                <MediaDatabaseDownloadListItem item={item} setter={setter} />
              </li>
            ))}
          </ul>
        </section>
      )}
    </>
  )
}

export default MediaDatabaseDownloadList
